<template>
  <tabs
    :options="{ useUrlFragment: false }"
    class="search-tabs"
    @changed="tabChanged"
  >
    <tab
      :key="categoryPanel.id"
      :name="categoryPanel.name"
      :id="categoryPanel.categoryId"
      v-for="categoryPanel in categoryPanels"
    >
      <div class="input-item" v-if="categoryPanel.isInput">
        <img class="icon-search" :src="iconInputSearch" alt="search" />
        <form action @submit.prevent="submit">
          <input
            placeholder="店名を入力"
            v-model="searchText"
            @focus="scrollToView"
            @keyup="scrollToView"
          />
        </form>
      </div>

      <genre-list
        v-if="categoryPanel.content"
        :allGenresSelected="allGenresSelected"
        :genreList="genres(categoryPanel.categoryId)"
        :isGenreSelected="isGenreSelected"
        @allGenresToggled="allGenresToggled"
        @genreToggled="genreToggled"
      >
      </genre-list>
    </tab>
  </tabs>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import GenreList from "./GenreList"
import IconInputSearch from "../../assets/icon-input-search.svg"
import IconInputClear from "../../assets/icon-input-clear.svg"

export default {
  data() {
    return {
      iconInputSearch: IconInputSearch,
      iconInputClear: IconInputClear,
      categoryPanels: [
        {
          name: "店名検索",
          isInput: true,
          id: "name"
        },
        {
          name: "小売業",
          content: [],
          id: "shop",
          categoryId: 1
        },
        {
          name: "飲食業",
          content: [],
          id: "food",
          categoryId: 2
        },
        {
          name: "サービス業",
          content: [],
          id: "service",
          categoryId: 3
        },
        {
          name: "医療・介護",
          content: [],
          id: "medical",
          categoryId: 4
        }
      ]
    }
  },

  methods: {
    submit() {
      this.$emit("searchRequested")
    },

    scrollToView({ target }) {
      target.scrollIntoView()
      setTimeout(() => target.scrollIntoView(), 100)
    },

    tabChanged({ tab }) {
      if (!tab.id) {
        // this.searchByTextActivated()
        return
      }

      this.categorySelected(tab.id)
    },

    ...mapActions("nav", ["exitSearchMode"]),
    ...mapActions("search", [
      "categorySelected",
      "allGenresToggled",
      "genreToggled"
    ])
  },

  computed: {
    searchText: {
      get() {
        return this.$store.getters["search/searchText"]
      },

      set(value) {
        this.$store.dispatch("search/searchTextChanged", value)
      }
    },

    ...mapGetters("search", ["allGenresSelected", "genres", "isGenreSelected"])
  },

  components: {
    GenreList
  }
}
</script>

<style src="./NameIndustryRefine.css"></style>
